/**
 * tell zone.js which events should be handled passive
 */
if (typeof window !== 'undefined') {
  (window as any)['__zone_symbol__PASSIVE_EVENTS'] = ['scroll', 'touchstart', 'touchmove'];
}
